import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    viviendas: [],
  },

  getters: {
    getViviendas: (state) => state.viviendas,
  },

  mutations: {
    SET_VIVIENDAS(state, viviendas) {
      state.viviendas = viviendas;
    },
  },

  actions: {
    async fetchViviendas({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiasclinicas/${idPersonal}/viviendas`)
        .then((response) => {
          commit('SET_VIVIENDAS', response.data.data);
        });
    },

    async saveVivienda(context, vivienda) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiasclinicas/${idHistoriaClinica}/viviendas`, vivienda);
    },

    async updateViviendas(_, viviendas) {
      await axios
        .put(`PoliciaCuadrantes/C3/personal/${viviendas.fk_idPersonal}/viviendas/${viviendas.fk_idViviendas}`, viviendas);
    },
  },
};
